import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '@adsk/bim360-matrix-react-icon-button';
import SvgIcon from '@adsk/bim360-matrix-react-svg-icon';
import navigationArrow from '@adsk/bim360-matrix-react-assets/navigation-arrow.svg';
import './_NavigationArrow.scss';

/**
 * Component for navigation arrows
 *
 */
const NavigationArrow = ({
  isPrevious,
  disabled,
  onClick,
  className,
  arrow,
  iconSize,
  dataTestid
}) => {
  const moreProps = {};
  if (dataTestid) {
    moreProps['data-testid'] = dataTestid;
  }
  return (
    <IconButton
      className={`NavigationArrow NavigationArrow--${
        isPrevious ? 'previous' : 'next'
      } ${className} `}
      onClick={onClick}
      disabled={disabled}
      {...moreProps}
    >
      <SvgIcon
        width={`${iconSize}px`}
        height={`${iconSize}px`}
        transform={isPrevious ? `rotate(180 ${iconSize / 2} ${iconSize / 2} )` : null}
      >
        {arrow}
      </SvgIcon>
    </IconButton>
  );
};

NavigationArrow.propTypes = {
  /**
   * true if arrow is for previous item, false otherwise
   */
  isPrevious: PropTypes.bool,
  /**
   * true if arrow is disabled, false otherwise
   */
  disabled: PropTypes.bool,
  /**
   * callback to be called when clicked
   */
  onClick: PropTypes.func,
  /**
   * the func (usually svg) of the arrow component
   */
  arrow: PropTypes.func,
  /**
   * additional classNames
   */
  className: PropTypes.string,
  /**
   * number in px of the arrow icon height and width
   */
  iconSize: PropTypes.number,
  /**
   * data-testid for auto testing
   */
  dataTestid: PropTypes.string
};

NavigationArrow.defaultProps = {
  arrow: navigationArrow,
  iconSize: 16,
  disabled: false
};

export default NavigationArrow;
